import { Box } from "@mui/material"
import { VerifiedOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import CertificationLegend from "./CertificationLegend"

import { Button } from "@/components/common/Button"
import { CertificationDialogType } from "@/screens/Companies/edit/components/certification/types"

interface CompanyCertificationHeaderProps {
  setDialogOpen: (open: CertificationDialogType) => void
}

const CompanyCertificationHeader: FC<CompanyCertificationHeaderProps> = ({ setDialogOpen }) => {
  return (
    <Box className='flex justify-between'>
      <CertificationLegend />

      <Box className='flex items-center'>
        <Button
          size='small'
          appearance='outlined'
          onClick={() => setDialogOpen(CertificationDialogType.ADD_CERTIFICATION)}
        >
          <VerifiedOutlined />
          Add Certification
        </Button>
      </Box>
    </Box>
  )
}

export default CompanyCertificationHeader
